import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiTagModule,
  TuiSelectModule,
} from '@taiga-ui/legacy';
import { TuiFiles } from '@taiga-ui/kit';
import { TuiIcon, TuiButton, TuiDataList } from '@taiga-ui/core';
import { ComponentsModule } from '@src/app/components';
import { TestingModule } from '@src/app/modules/testing/testing.module';
import { CustomNamesTabsModule } from '@src/app/modules/custom-name-tabs';
import { PhotoModule } from '@src/app/modules/photo';

import { SharedModule } from '../shared.module';

import { FieldComponent } from './field.component';
import { FieldPhoneComponent } from './field-phone/field-phone.component';
import { FieldEmailComponent } from './field-email/field-email.component';
import { FieldWebPageComponent } from './field-web-page/field-web-page.component';
import { FieldWebDocumentComponent } from './field-web-document/field-web-document.component';
import { FieldSocialNetworkComponent } from './field-social-network/field-social-network.component';
import { FieldMessengerComponent } from './field-messenger/field-messenger.component';
import { FieldTextComponent } from './field-text/field-text.component';
import { FieldFileComponent } from './field-file/field-file.component';
import { FieldUserComponent } from './field-user/field-user.component';
import { FieldOrganisationComponent } from './field-organisation/field-organisation.component';
import { FieldFilesListComponent } from './field-files-list/field-files-list.component';
import { FieldParseLinksComponent } from './field-parse-links/field-parse-links.component';
import { FieldCommitteeComponent } from './field-committee/field-committee.component';
import { FieldNewTextComponent } from './field-new-text/field-new-text.component';
import { FieldNewUserComponent } from './field-new-user/field-new-user.component';
import { FieldNewCommitteeComponent } from './field-new-committee/field-new-committee.component';
import { FieldNewWebPageComponent } from './field-new-web-page/field-new-web-page.component';
import { FieldNewParseLinksComponent } from './field-new-parse-links/field-new-parse-links.component';

@NgModule({
  declarations: [
    FieldComponent,
    FieldPhoneComponent,
    FieldEmailComponent,
    FieldWebPageComponent,
    FieldWebDocumentComponent,
    FieldSocialNetworkComponent,
    FieldMessengerComponent,
    FieldTextComponent,
    FieldFileComponent,
    FieldUserComponent,
    FieldOrganisationComponent,
    FieldFilesListComponent,
    FieldParseLinksComponent,
    FieldCommitteeComponent,
    FieldNewTextComponent,
    FieldNewUserComponent,
    FieldNewCommitteeComponent,
    FieldNewWebPageComponent,
    FieldNewParseLinksComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    TuiInputModule,
    TuiIcon,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    ...TuiFiles,
    TuiButton,
    ComponentsModule,
    TestingModule,
    CustomNamesTabsModule,
    PhotoModule,
    TuiTagModule,
    TuiSelectModule,
    ...TuiDataList,
  ],
  exports: [FieldComponent, FieldTextComponent],
})
export class FieldModule {}
